(function () {
  console.log("🧩 [Popup] Avvio...");

  /**
   * 🌍 Traduzioni supportate
   */
  const translations = {
    it: {
      title: "Conferma personalizzazione",
      message:
        "Ti ricordiamo che né i prodotti personalizzati né quelli realizzati in taglie standard possono essere restituiti o modificati dopo l’acquisto, in quanto personalizzati nelle restanti componenti.<br><br>Nel caso avessi scelto MISURE PERSONALIZZATE, verrai contattato dai nostri stilisti per verificare le misure inserite",
      checkbox: "Accetto e desidero procedere con l’acquisto",
      cancel: "Annulla",
      confirm: "Conferma",
      alert: "Per procedere, devi accettare le condizioni.",
    },
    en: {
      title: "Confirm customization",
      message:
        "Please note that customized products cannot be returned or modified after purchase.",
      checkbox: "I accept and wish to proceed with the purchase",
      cancel: "Cancel",
      confirm: "Confirm",
      alert: "You must accept the terms to proceed.",
    },
    fr: {
      title: "Confirmer la personnalisation",
      message:
        "Veuillez noter que les produits personnalisés ne peuvent pas être retournés ni modifiés après l'achat.",
      checkbox: "J'accepte et je souhaite poursuivre l'achat",
      cancel: "Annuler",
      confirm: "Confirmer",
      alert: "Vous devez accepter les conditions pour continuer.",
    },
    de: {
      title: "Personalisierung bestätigen",
      message:
        "Bitte beachten Sie, dass personalisierte Produkte nach dem Kauf nicht zurückgegeben oder geändert werden können.",
      checkbox: "Ich akzeptiere und möchte den Kauf fortsetzen",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      alert: "Bitte akzeptieren Sie die Bedingungen, um fortzufahren.",
    },
  };

  const locale = (window.Shopify && Shopify.locale) || "it";
  const t = translations[locale] || translations.it;

  /**
   * 🔍 Aspetta che Zepto Product Personalizer sia pronto
   */
  function waitForPersonalizer() {
    const isCustomProduct = document.body.classList.contains(
      "template-product-prodotto-personalizzabile"
    );
    if (!isCustomProduct) {
      console.log("📦 [Popup] Prodotto standard – nessun popup necessario.");
      return;
    }

    const target = document.querySelector(".pplr-wrapper, .pplr_thumb_image");
    if (target) {
      console.log("🎯 [Popup] Personalizer trovato - inizializzo popup...");
      initPopup();
      return;
    }

    console.log("⌛ [Popup] In attesa del personalizer...");
    setTimeout(waitForPersonalizer, 500);
  }

  /**
   * 💬 Inizializza popup di conferma con animazione
   */
  function initPopup() {
    if (document.getElementById("confirm-popup-overlay")) return;

    // Aggiungo CSS per animazioni
    const style = document.createElement("style");
    style.textContent = `
      #confirm-popup-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.55);
        display: none;
        justify-content: center;
        align-items: center;
        z-index: 99999;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      #confirm-popup-overlay.visible {
        display: flex;
        opacity: 1;
      }

      #confirm-popup {
        background: #fff;
        padding: 24px 28px;
        border-radius: 12px;
        max-width: 480px;
        width: 90%;
        box-shadow: 0 10px 40px rgba(0,0,0,0.25);
        font-family: inherit;
        text-align: left;
        transform: scale(0.8);
        opacity: 0;
        transition: all 0.3s ease;
      }

      #confirm-popup.visible {
        transform: scale(1);
        opacity: 1;
      }

      #confirm-popup h3 {
        margin-bottom: 16px;
        font-size: 1.8rem;
      }

      #confirm-popup p {
        font-size: 1.4rem;
        margin-bottom: 14px;
      }

      #confirm-popup label {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 20px;
        font-size: 1.2rem;
      }

      #confirm-popup button {
        border: none;
        border-radius: 6px;
        padding: 8px 16px;
        cursor: pointer;
        transition: background 0.2s ease;
      }

      #confirm-popup-cancel {
        background: #ccc;
        color: #000;
      }

      #confirm-popup-cancel:hover {
        background: #bbb;
      }

      #confirm-popup-confirm {
        background: #000;
        color: #fff;
      }

      #confirm-popup-confirm:hover {
        background: #333;
      }
    `;
    document.head.appendChild(style);

    // Popup HTML
    const popupHTML = `
      <div id="confirm-popup-overlay">
        <div id="confirm-popup">
          <h3>${t.title}</h3>
          <p>${t.message}</p>
          <label>
            <input type="checkbox" id="confirm-popup-check">
            <span>${t.checkbox}</span>
          </label>
          <div style="display: flex; justify-content: flex-end; gap: 10px;">
            <button id="confirm-popup-cancel">${t.cancel}</button>
            <button id="confirm-popup-confirm">${t.confirm}</button>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML("beforeend", popupHTML);

    const overlay = document.getElementById("confirm-popup-overlay");
    const popup = document.getElementById("confirm-popup");
    const checkbox = document.getElementById("confirm-popup-check");
    const btnConfirm = document.getElementById("confirm-popup-confirm");
    const btnCancel = document.getElementById("confirm-popup-cancel");

    let popupAlreadyConfirmed = false;

    // Mostra popup con animazione
    function showPopup() {
      overlay.classList.add("visible");
      setTimeout(() => popup.classList.add("visible"), 50);
    }

    // Chiudi popup con animazione
    function hidePopup() {
      popup.classList.remove("visible");
      overlay.classList.remove("visible");
      setTimeout(() => (overlay.style.display = "none"), 300);
    }

    // Intercetta i click "Aggiungi al carrello"
    const addToCartButtons = document.querySelectorAll(
      'form[action="/cart/add"] [type="submit"], form[id^="product-form"] [type="submit"], button[name="add"]'
    );

    addToCartButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (popupAlreadyConfirmed) return;
        e.preventDefault();
        e.stopPropagation();
        overlay.style.display = "flex";
        showPopup();
      });
    });

    btnCancel.addEventListener("click", hidePopup);

    btnConfirm.addEventListener("click", () => {
      if (!checkbox.checked) {
        alert(t.alert);
        return;
      }

      popupAlreadyConfirmed = true;
      hidePopup();

      // Simula click reale sul bottone originale
      const addBtn = document.querySelector(
        'form[action="/cart/add"] [type="submit"], form[id^="product-form"] [type="submit"], button[name="add"]'
      );
      if (addBtn) {
        console.log("🛒 [Popup] Conferma → click simulato sul pulsante originale");
        addBtn.click();
      } else {
        console.warn("⚠️ Nessun pulsante trovato — fallback su form.submit()");
        const form =
          document.querySelector('form[action="/cart/add"], form[id^="product-form"]') ||
          document.querySelector("form[action*='/cart']");
        form?.submit();
      }
    });

    console.log(`✅ [Popup] Conferma personalizzazione pronta (${locale}).`);
  }

  // Avvio
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForPersonalizer);
  } else {
    waitForPersonalizer();
  }
})();
